import React from 'react';
import { ProductCardProps } from '../../types';
import { twMerge } from 'tailwind-merge';

export default function CardBodyMkplEta(props: Partial<ProductCardProps>) {
  const { data, className, showSoldBy = true, etaClassName = 'enki-body-2xs-medium' } = props;
  const { eta_range } = data?.vender_info_view || { eta_range: '' };

  if (!!eta_range && showSoldBy) {
    return (
      <div
        data-testid="wid-product-card-eta"
        onClick={e => e.stopPropagation()}
        className={twMerge(
          'max-w-full whitespace-nowrap overflow-hidden leading-4 flex items-center text-surface-100-fg-minor',
          className,
          etaClassName
        )}
        dangerouslySetInnerHTML={{ __html: eta_range }}></div>
    );
  }
  return null;
}
